let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5dt09")).then(() => parcelRequire('jdlqN'));